@if (!!data && !!data.length) {
  <div class="h-100 w-100">
    @if (loadInformation) {
      <div echarts [options]="chartOptions" [merge]="updateOptions" [loading]="isLoading"></div>
    }
  </div>
}
